// extracted by mini-css-extract-plugin
module.exports = {"add_new":"filters_add_new__26gRB"};